import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Tooltip,
  Spin,
  Select,
  Button,
  Space,
  Form,
} from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import { labelConfig, staticConfig, apiConfig } from "../../customer.config";

import { rightAction } from "../../../../redux/actions";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";
import StatusSelect from "../../../../components/CustomStatusSelect";
import CustomPagination from "../../../../components/CustomPagination";

const { Text } = Typography;

const ManageRecurringDepositAcc = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const columns = [
    {
      title: labelConfig.customerId,
      dataIndex: "clientId",
    },
    {
      title: labelConfig.accounNumber,
      dataIndex: "accountNo",
      sorter: (a, b) => a["accountNo"].localeCompare(b["accountNo"]),
    },
    {
      title: labelConfig.accountName,
      dataIndex: "clientName",
      sorter: (a, b) => a.clientName.localeCompare(b.clientName),
    },
    {
      title: labelConfig.branch,
      dataIndex: "branch",
      sorter: (a, b) => a.branch.localeCompare(b.branch),
    },
    {
      title: labelConfig.product,
      dataIndex: "savingsProductName",
    },
    {
      title: labelConfig.status,
      dataIndex: "status",
    },
  ];

  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [recurringDepositAccountList, setRecurringDepositAccountList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(300);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isSearch, setIsSearch] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  console.log(recurringDepositAccountList, "recurringDepositAccountList");
  useEffect(() => {
    {
      BOM.HasPermission("READ_SAVINGSACCOUNT") && getRecurringDepositAccountListAction();
    }
    {
      BOM.HasPermission("CREATE_RECURRINGDEPOSITACCOUNT") && rightAction(cnt.RIGHT_ADD_BTN);
    }
  }, [selectedStatus]);

  const getRecurringDepositAccountListAction = (offset = 0, limit = Number(tableCount)) => {
    console.log(selectedStatus, "selectedStatus");
    const params = {
      status: selectedStatus > 0 ? selectedStatus : null,
      orderBy: "id",
      limit: limit,
      offset: offset,
      // accountType: 300,
      paged: true,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    const url = `${apiConfig.Recurringdepositaccounts}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsSearch(false);
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        console.log(res, "res");
        // const objList = res.pageItems.filter(
        //   (item) => item?.depositType?.value?.toLowerCase() === "recurring deposit",
        // );
        const objList = res.pageItems;
        let tempArray = [];
        // console.log(objList);
        // return;

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            accountNo: element?.accountNo ? element?.accountNo : "-",
            clientName: element?.clientName ? element?.clientName : "-",
            clientId: element?.clientId ? element?.clientId : "-",
            status: handleFlgStatus(element?.status?.value, {}, true),
            branch: element?.officeName ? element?.officeName : "-",
            savingsProductName: element?.depositProductName ? element?.depositProductName : "-",
            otherKeys: {
              statusValue: element?.status?.value, // The status value will be used on the detail screen
              accountNo: element?.accountNo,
            },
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setRecurringDepositAccountList(tempArray);
        setTotalItems(res.totalFilteredRecords);
        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        orderBy: "id",
      };

      let body = {
        session,
        params,
      };

      const url = `${apiConfig.Recurringdepositaccounts}`;

      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          reject(err);
        } else {
          setIsLoading(false);

          const objList = res.pageItems.filter(
            (item) => item?.depositType?.value?.toLowerCase() === "recurring deposit",
          );
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo ? element?.accountNo : "-",
              clientName: element?.clientName ? element?.clientName : "-",
              clientId: element?.clientId ? element?.clientId : "-",
              status: handleFlgStatus(element?.status?.value, {}, true),
              branch: element?.officeName ? element?.officeName : "-",
              savingsProductName: element?.savingsProductName ? element?.savingsProductName : "-",
              otherKeys: {
                statusValue: element?.status?.value, // The status value will be used on the detail screen
                accountNo: element?.accountNo,
              },
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_SAVINGSACCOUNT") && cnt.RIGHT_DETAIL_BTN,
      // BOM.HasPermission("UPDATE_RECURRINGDEPOSITACCOUNT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function selectTableCount(value) {
    setTableCount(value);
    onRefresh(0, Number(value));
  }

  function handleOnView() {
    // console.log(selectedRow);  return

    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-recurring-deposit-account", {
        state: { id: selectedRow.id, ...selectedRow.otherKeys },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-recurring-deposit-account", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);
    setIsSearch(true);
    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "savings,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      setIsSearch(true);
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // console.log(res);
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.entityId,
            id: element?.entityId,
            accountNo: element?.entityAccountNo ? element?.entityAccountNo : "-",
            clientName: element?.parentName ? element?.parentName : "-",
            clientId: element?.parentId ? element?.parentId : "-",
            status: handleFlgStatus(element?.entityStatus?.value, {}, true),
            branch: element?.officeName ? element?.officeName : "-",
            savingsProductName: element?.entityName ? element?.entityName : "-",
            otherKeys: {
              statusValue: element?.entityStatus?.value, // The status value will be used on the detail screen
              accountNo: element?.accountNo,
            },
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setRecurringDepositAccountList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    setIsSearch(false);
    useForm.resetFields();
    getRecurringDepositAccountListAction(offset, limit);
    setCurrentPage(1);
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView} onAdd={handleOnCreate}>
      <TopContent
        pageTitle={labelConfig.manageRecurringDepositAccount}
        pageItems={staticConfig.manageRecurringDepositAccountBreadcrumbItems}
      />

      {/* RENDER TABLE LIST HERE*/}
      <Card
        title={
          <>
            {labelConfig.recurringDepositAccountList}{" "}
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={() => onRefresh(0, Number(tableCount))}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              {labelConfig.refresh}
            </Button>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>{labelConfig.show}</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>{labelConfig.entries}</Text>
            </div>

            {/* <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div> */}
            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    style={{
                      width: "100%",
                    }}
                  >
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by Account Number"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                    >
                      <SearchOutlined />
                    </Button>
                    <div style={{ marginLeft: "20px" }}>
                      {!isSearch && (
                        <div style={{ marginBottom: "auto", marginLeft: 10 }}>
                          <Select
                            value={selectedStatus}
                            options={staticConfig.newAccountStatusOptions}
                            onChange={(value) => setSelectedStatus(value)}
                            placeholder={"Select Status"}
                            dropdownStyle={{ width: "250px" }}
                            className="interbank-table-select"
                          />
                        </div>
                      )}
                      {/* <StatusSelect
                        statusOptions={staticConfig.accountStatusOptions}
                        originalList={originalList}
                        onFilteredListChange={setRecurringDepositAccountList}
                        useRawValue={true}
                        rawValuePath="otherKeys.statusValue"
                      /> */}
                    </div>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
            {/* <DownloadTableButtons
              downloadData={recu}
              columns={columns}
              fileName={"Recurring Deposit Account List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={recurringDepositAccountList}
            bordered
            pagination={false}
            // pagination={{
            //   position: "bottomCentre",
            //   pageSize: tableCount,
            // }}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageRecurringDepositAcc);
